<div cdkDropListGroup>
<div [ngClass]="{'correctFlex': allCorrect, 'incorrectFlex': !allCorrect}">
  <div 
    *ngIf="allCorrect"
    style="width: 10%; margin: 10px auto 10px auto">
    <svg class="checkmark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52">
      <circle class="checkmark__circle" cx="26" cy="26" r="25" fill="none"/>
      <path class="checkmark__check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8"/>
    </svg>
  </div>
</div>
    
    <!-- Verse Prompts -->
    <div 
      *ngIf="question.questionType != 'trueOrFalse' && question.questionType !== 'truthConfirmation' && question.questionType !== 'text'" 
      class="content_container"
    >
      <div class="spanwrapper" >
        <span  *ngFor="let vp of versePrompts ; index as i;" > 
          <span class="captionText">
            
            {{vp.textBefore}}
            <div 
              [attr.id]="versePromptIDs[i]" 
              class="blank regularText regularBorder" 
              (click)="selectBlank(vp)" 
              cdkDropList
              (cdkDropListDropped)="onDrop($event, i)"
              [cdkDropListData]="answersArray"
              >
              <div 
                *ngIf="answers[i] && question.questionType !== 'radio'"
                class=removeChoice (click)="selectAnswer(answers[i], $event, true)">&times;
              </div>
              <div 
                *ngIf="answers[i] && answers[i].choice"  
                (click)="closeModal($event)" 
                class="choicePadding" >
                <div 
                  
                  class="choiceLabel captionText"  
                  [ngClass]="{correct:answers[i].correct, incorrect:!answers[i].correct}"
                  (click)="selectAnswer(answers[i], $event)"
                  >
                    {{answers[i]?.choice}}   
                </div>
              </div>
            </div>
            {{vp.textAfter}}
            </span>
            <span *ngIf="vp.newline"><br *ngFor="let n of vp.newline"></span>
          </span>
      </div>
    </div>

        <div *ngIf="question.questionType === 'radio'" class="radioButtonContainer flexy">
            <div *ngFor="let c of question.choices"  style="margin: 10px;">
              <label class="container">
                  <span class=" radioLabel captionText">{{c}}</span>
                    <input type="radio" name="radio" (click)="saveRadioAnswer(c)">
                    <span class="radiomark"></span>
                </label>
            </div>
          </div>

        <!-- True or False -->
        <div *ngIf="question.questionType === 'trueOrFalse'">
            <div class="radioButtonContainer">
                <!-- <h3 style="text-align: center"><span class="captionText extraBold">True or False? </span><span class="bold regularText reallyDarkGreyText">{{question.trueFalseQuestion}}</span></h3> -->
                <h3 style="text-align: center"><span class="bold regularText reallyDarkGreyText">{{question.trueFalseQuestion}}</span></h3>
                <form class="flexy" >
                    <label class="container">
                        <span class="trueFalseLabel captionText">{{config?.questionTemplateTrue}}</span>
                          <input type="radio" name="radio" (click)="saveTrueOrFalse('true')">
                          <span class="radiomark"></span>
                      </label>
                      &nbsp;&nbsp;&nbsp;
                      <label class="container">
                          <span class="trueFalseLabel captionText">{{config?.questionTempalteFalse}}</span>
                            <input type="radio" name="radio" (click)="saveTrueOrFalse('false')">
                            <span class="radiomark"></span>
                      </label>
                </form>
            </div>
          </div>

        <!-- text -->
        <div *ngIf="question.questionType === 'text'">
            <!-- <div class="content_container" [innerHtml]="body | newline"> -->
              <div class="content_container">
              <h2 *ngFor="let b of question.text" class="narrowText reallyDarkGreyText">{{b}}<br></h2>
            </div>
        </div>

        <!-- truthConfirmation -->
        <div *ngIf="question.questionType === 'truthConfirmation'">
          <div class="radioButtonContainer">
              <!-- <h3 style="text-align: center"><span class="captionText extraBold">True or False? </span><span class="bold regularText reallyDarkGreyText">{{question.trueFalseQuestion}}</span></h3> -->
              <form class="flexy" >



                  <label class="container">
                      <span class="radioLabel captionText">{{config?.questionTemplateYes}}</span>
                        <input type="radio" name="radio" (click)="truthConfirmed('true')">
                        <span class="radiomark"></span>
                    </label>
                    &nbsp;&nbsp;&nbsp;
                    <label class="container">
                        <span class="radioLabel captionText">{{config?.questionTemplateNo}}</span>
                          <input type="radio" name="radio" (click)="truthConfirmed('false')">
                          <span class="radiomark"></span>
                    </label>
                </form>
          </div>
        </div>
        <!-- Checkbox Answers -->
        <div *ngIf="question.questionType === 'checkbox'">

        </div>


        <!-- [dragula]="wordBag" -->
        <!-- [dragulaModel]='question.choices'  -->
        <!-- [dragulaOptions]="dragOptions" -->

        <!-- Word cloud -->
        <div 
          cdkDropList
          *ngIf="question.questionType === 'wordCloud'"
          style="touch-action: none;"
          class="choiceContainer" 
          cdkDropListOrientation="horizontal"
          [cdkDropListData]="question.choices"
          (cdkDropListDropped)="onDrop($event, 'wordCloud')"
        >
              <div  *ngFor="let c of question.choices"  >
              <div 
               cdkDrag
                [cdkDragData]="c"
                *ngIf="shouldShowChoice(c)" 
                class="choiceLabel captionText unselected" 
                style="touch-action: none;" 
                (click)="selectChoice(c, $event)" >{{c}}</div>
            </div>
        </div>

        <div [attr.id]="bodyID" *ngIf="allCorrect && question.body" class="bodyContainer"><div class="body regularText fade" [innerHtml]="question.body | newline"></div></div>
</div>